<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">P<span class="smallcaps">ART </span>O<span class="smallcaps">NE </span></h1>
<p class="center"> </p>
<p class="center"><em class="italic">Those who know say nothing; </em><br/><em class="italic">those who speak do not know</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ferocity_00002.vue?52b24923